module.exports = __webpack_public_path__ + "static/background-a19dac2acdb4fd9b168d5ff4b608aee2.mp4";